import React from 'react';
import { useContent } from '../i18n';

/**
 * Responsive <img> for an entry from asset/photos.
 * `sizes` should describe how wide the image is rendered so the browser can
 * pick the 640px file on small screens. Lazy-loads unless `priority` is set.
 */
function Photo({ photo, sizes = '(max-width: 768px) 100vw, 50vw', priority = false, alt, ...rest }) {
  const translatedAlts = useContent('photoAlts');
  return (
    <img
      src={photo.src}
      srcSet={photo.srcSet}
      sizes={sizes}
      width={photo.width}
      height={photo.height}
      alt={alt ?? translatedAlts[photo.id] ?? photo.alt}
      loading={priority ? 'eager' : 'lazy'}
      fetchpriority={priority ? 'high' : undefined}
      decoding="async"
      {...rest}
    />
  );
}

export default Photo;
